{
    "Accessibility menu": "قائمة إمكانية الوصول",
    "Close": "إغلاق",
    "Content adjustments": "تعديلات المحتوى",
    "Navigation adjustments": "تعديلات التنقل",
    "Text Align": "محاذاة النص",
    "Align Left": "محاذاة لليسار",
    "Align Center": "توسيط",
    "Align Right": "محاذاة لليمين",
    "Adjust Font Size": "ضبط حجم الخط",
    "Highlight Title": "تمييز العنوان",
    "Highlight Links": "تمييز الروابط",
    "Readable Font": "خط مقروء",
    "Colour adjustments": "تعديلات الألوان",
    "Dark Contrast": "تباين داكن",
    "Light Contrast": "تباين فاتح",
    "High Contrast": "تباين عالي",
    "High Saturation": "تشبع عالي",
    "Low Saturation": "تشبع منخفض",
    "Monochrome": "أحادي اللون",
    "Tools": "الأدوات",
    "Reading Guide": "دليل القراءة",
    "Big Cursor": "مؤشر كبير",
    "Increase Font Size": "زيادة حجم الخط",
    "Decrease Font Size": "تقليل حجم الخط",
    "Letter Spacing": "المسافة بين الحروف",
    "Line Height": "ارتفاع السطر",
    "Font Weight": "سمك الخط",
    "Dyslexia Font": "خط عسر القراءة",
    "Language": "اللغة",
    "Accessibility widget": "فتح قائمة إمكانية الوصول",
    "Accessibility Profiles": "ملفات إمكانية الوصول",
    "Cognitive Disability": "الإعاقة المعرفية",
    "Seizure Safe": "آمن من النوبات",
    "Accessibility statement": "بيان إمكانية الوصول",
    "ADHD": "فرط الحركة ونقص الانتباه",
    "Low Vision": "ضعف البصر",
    "Pause Animations": "إيقاف الرسوم المتحركة",
    "Animation paused": "تم إيقاف الحركة مؤقتًا",
    "Reset all settings": "إعادة تعيين الإعدادات",
    "Shortcut:": "اختصار:",
    "Epilepsy Safe Mode": "وضع آمن للصرع",
    "Mute sounds": "كتم الأصوات",
    "Page read": "قراءة الصفحة",
    "Page read controls": "عناصر التحكم في قراءة الصفحة",
    "Pause": "إيقاف مؤقت",
    "Resume": "استئناف",
    "Stop": "إيقاف",
    "Settings": "الإعدادات",
    "Speed": "السرعة",
    "Voice": "الصوت",
    "Close accessibility menu": "إغلاق قائمة إمكانية الوصول",
    "Back to accessibility menu": "العودة إلى قائمة إمكانية الوصول",
    "Search languages": "البحث عن اللغات",
    "Selected language": "اللغة المحددة",
    "View accessibility statement (opens in new window)": "عرض بيان إمكانية الوصول (يفتح في نافذة جديدة)",
    "Visit CookieYes website (opens in new window)": "زيارة موقع CookieYes (يفتح في نافذة جديدة)",
    "Reset all accessibility settings to default": "إعادة تعيين جميع إعدادات إمكانية الوصول إلى الوضع الافتراضي"
}
